import KnowMore from "@/components/ui/know-more";
import Image from "next/image";
import React, { useState } from "react";

export default function Reading({ data = [] }) {
  const [open, setOpen] = useState(false);
  const displayedClients = open ? data : data.slice(0, 20);
  return (
    <div
      className="bg-beige w-full flex flex-col items-center justify-center py-16"
      id="publications"
    >
      <div className="flex flex-col w-full gap-8 px-4">
        <div className="w-full flex flex-row gap-2 justify-between border-b-[0.5px] border-darkGrey/50 md:px-4 px-0 md:pb-6 pb-4">
          <p className="text-[#292929]/70 font-havletica text-base md:text-[20px]">
            Reading Material
          </p>
          {/* <KnowMore path="/">Sort</KnowMore> */}
        </div>
        <div className="w-full flex flex-col gap-10 md:gap-10 overflow-hidden md:px-4">
          {displayedClients?.map((publication, key) => {
            return <ReadingPost key={key} data={publication} />;
          })}
        </div>
      </div>
      {data?.length > 20 && (
        <div
          onClick={() => setOpen(!open)}
          className="mt-12 mx-auto cursor-pointer text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit"
        >
          {!open ? "View More" : "View less"}
        </div>
      )}
    </div>
  );
}

export const ReadingPost = ({ data }) => {
  const { publication, publicationTitle, description, link, tag, image, logo } =
    data;

  return (
    <div className="flex flex-col md:flex-row w-full border-b-[0.5px] border-darkGrey/50 last:border-b-0 md:pb-6 pb-8 md:gap-8">
      <div className="flex items-start justify-start relative w-full md:w-[45vw] shrink-0 md:h-[23vw] h-[200px] overflow-hidden mb-4 ">
        <Image
          src={
            image?.data?.attributes?.formats?.medium?.url ??
            image?.data?.attributes?.formats?.large?.url ??
            image?.data?.attributes?.url ??
            "/images/placeholder.svg"
          }
          alt={image?.data?.attributes?.name ?? "blog-image"}
          sizes="(max-width: 479px) 500px, 100vw"
          fill
          className="w-full h-full object-cover"
        />
        <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center bg-black/30  backdrop-blur-[2px] overflow-hidden">
          <div className="md:w-[300px] md:h-[300px] w-[250px] h-[250px] flex flex-col items-center justify-center relative">
            <Image
              src={logo?.data?.attributes?.url ?? "/images/placeholder.svg"}
              alt={publicationTitle}
              fill
              sizes="(max-width: 479px) 500px, 500px"
              className="object-contain p-4"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col gap-2 justify-center lg:max-w-[600px]">
        <p className="text-sm text-darkGrey/70">{`${tag} | ${publication}`}</p>
        <p className="md:text-[20px] text-base text-darkGrey/90 !leading-tight">
          {publicationTitle}
        </p>
        <div
          className="text-sm text-darkGrey/80 font-light !leading-tight"
          dangerouslySetInnerHTML={{ __html: description }}
        ></div>

        {link && (
          <a
            href={link}
            target="_blank"
            rel="nofollow"
            className="mt-4 cursor-pointer text-sm underline text-darkGrey hover:text-darkGrey/50 transition-all duration-300 ease w-fit"
          >
            Read Now
          </a>
        )}
      </div>
    </div>
  );
};
